









import {WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {bus} from "@/main"
import {defineComponent} from "@vue/composition-api"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Text(),
    widget: "JobsRaisedInAMonth",
    title: "Reactive Job lines raised for month to date",
    _description: "",
    params: {
      hdJobCategory: {...WParamTpl.hdJobCategory(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const p = extractParams(params)
  return {
    value: formatNumberWithGrouping((await executeQuery(
      "FMS_DB",
      "jobsRaised",
      {ppmRepair: 2, category: p.jobCategory, year: p.year, month: p.month, day: 0}))[0].Value),
  }
}

async function titleCallback(config: any) {
  return getTitle(config.params)
}

export default defineComponent({
  props: {config: {type: Object, required: true}},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      const p = extractParams(props.config && props.config.params)
      bus.$emit("chartPopup", {
        title: config().title,
        component: () => import("@/components/drilldowns/JobsRaisedDrillDown.vue"),
        componentArgs: {...extractParams(props.config.params), day: 0, hdPPMRepairAll: 2},
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
